import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import * as styles from "./index.module.css";
import { get, zip, merge } from "lodash-es";
import { vueBailDepCollector } from "../../../../../../lib/utils/vue";
let SelectorRenameForm = class SelectorRenameForm extends Vue {
  constructor() {
    super(...arguments);
    this.visible = false;
    /** 用户可以同时修改selector和pseudo */
    this.formModelData = {
      selector: '',
      pseudo: ''
    };
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  /** 启动popover的时候拷贝一份selector给表单 用响应式监听填充给表单感觉有点多余 */
  openPopover() {
    this.formModelData = {
      selector: this.styleInfo.selectorClass.selector,
      pseudo: this.styleInfo.pseudoClass.selector
    };
  }
  getMergedStyleObj() {
    const comp = this.designer.activeComp;
    const emptyStaticStyle = Object.keys(get(comp, 'style', {})).length === 0;
    const style = emptyStaticStyle ? {} : {
      '': {
        '': get(comp, 'style')
      }
    };
    const extraStyle = get(comp, 'extraStyle');
    const mergedStyle = merge({}, style, extraStyle);
    return mergedStyle;
  }
  /** 准确来说是拷贝Style 并不负责删除冗余
   *
   * 将selectorFrom中的pseudoForm 迁移到selectorTo的pseudoTo中
   * 若pseudoFrom为空 表示迁移selector下全部的pseudo
   *
   * */
  transferStyle(options) {
    /** 迁移的逻辑: 1遍历 [selectorFrom]中的所有已存在pseudo
      2 按照options.pseudoFrom filter出来 如果是空数组的话就拉全部出来
      3. 写入selectorTo:pseudoTo  其中pseudoFrom和pseudoTo 一一对应
     */
    const pseudoLUT = get(this.getMergedStyleObj(), options.selectorFrom, {});
    /** 用来查询从a transfer 到b映射的的pseudo */
    const pseudoTransferLUT = zip(options.pseudoFrom, options.pseudoTo).reduce((result, [from, to]) => {
      result[from] = to;
      return result;
    }, {});
    Object.entries(pseudoLUT).filter(([key]) => {
      // 空数组不执行filter
      if (options.pseudoFrom.length === 0 || options.pseudoFrom.includes(key)) return true;
      return false;
    }).forEach(([key, value]) => {
      // 写入
      const transferAll = options.pseudoFrom.length === 0;
      const pseudoTo = transferAll ? key : pseudoTransferLUT[key];
      this.stylePanelState.setStylesBySelector(value, {
        selector: options.selectorTo,
        pseudo: pseudoTo
      });
    });
  }
  /** 迁移当前的class 到新的地方 但是对用户来说是重命名自定义的选择器*/
  async renameStyleSelector() {
    const {
      selectorClass,
      pseudoClass
    } = this.styleInfo;
    const {
      selector
    } = selectorClass;
    const {
      selector: pseudo
    } = pseudoClass;
    // 表单校验检查后就是合法的了
    try {
      const form = this.$refs.renameForm;
      await form.validate();
    } catch (e) {
      return;
    }
    const selectorChanged = this.formModelData.selector !== selector;
    const pseudoChanged = this.formModelData.pseudo !== pseudo;
    const comp = this.designer.activeComp;
    if (selectorChanged) {
      // 先处理修改selector
      // 特殊逻辑 如果是从root重命名的话 只迁移当前的pseudo
      if (selectorClass.selector === '') {
        this.transferStyle({
          selectorFrom: selector,
          selectorTo: this.formModelData.selector,
          pseudoFrom: [pseudo],
          pseudoTo: [pseudo]
        });
        if (pseudo === '') {
          this.$delete(comp, 'style');
        } else {
          this.$delete(get(comp, ['extraStyle', selector], {}), pseudo);
        }
      } else {
        // 否则 要连带所有已存在的pseudo进行迁移
        // 但是这个时候如果pseudo也变了呢? 迁移之后要再改一次pseudo
        this.transferStyle({
          selectorFrom: selector,
          selectorTo: this.formModelData.selector,
          pseudoFrom: [],
          pseudoTo: []
        });
        // 这时候就是重命名了 应该删除旧的selector
        this.$delete(get(comp, ['extraStyle'], {}), selector);
      }
    }
    // selector迁移之后再迁移pseudo
    if (pseudoChanged) {
      this.transferStyle({
        selectorFrom: this.formModelData.selector,
        selectorTo: this.formModelData.selector,
        pseudoFrom: [pseudo],
        pseudoTo: [this.formModelData.pseudo]
      });
      // 旧的pseudo要删掉
      this.$delete(get(comp, ['extraStyle', this.formModelData.selector], {}), pseudo);
    }
    if (selectorChanged || pseudoChanged) {
      this.$emit('notify', `${this.formModelData.selector}-${this.formModelData.pseudo}`);
      this.stylePanelState.currentSelector = this.formModelData.selector;
      this.stylePanelState.currentPseudoClass = this.formModelData.pseudo;
    }
    this.visible = false;
  }
  get rules() {
    const validator = (rule, value, cb) => {
      if (value && /^[0-9]*$/.test(value)) {
        cb('不能为纯数字');
        return;
      }
      cb();
    };
    const selectorDuplicate = (rule, value, cb) => {
      vueBailDepCollector(() => {
        if (value !== this.styleInfo.selectorClass.selector) {
          // 监测重名
          if (get(this.getMergedStyleObj(), [value])) {
            cb('选择器名字已存在');
            return;
          }
        }
        cb();
      });
    };
    const pseudoDuplicate = (rule, value, cb) => {
      vueBailDepCollector(() => {
        if (value !== this.styleInfo.pseudoClass.selector) {
          // 监测重名
          const pseudoCssObj = get(this.getMergedStyleObj(), [this.styleInfo.selectorClass.selector, value], {});
          if (Object.keys(pseudoCssObj).length !== 0) {
            cb('伪类名已存在');
            return;
          }
        }
        cb();
      });
    };
    const rules = {
      selector: [{
        validator,
        trigger: ['blur']
      }, {
        validator: selectorDuplicate,
        trigger: ['blur']
      }],
      pseudo: [{
        validator,
        trigger: ['blur']
      }, {
        validator: pseudoDuplicate,
        trigger: ['blur']
      }]
    };
    return rules;
  }
  render() {
    const h = arguments[0];
    const {
      formModelData
    } = this;
    return h("a-popover", {
      "attrs": {
        "trigger": "click",
        "placement": "bottom"
      },
      "model": {
        value: this.visible,
        callback: $$v => {
          this.visible = $$v;
        }
      }
    }, [h("div", {
      "class": styles.switchAndEditStyleButton,
      "on": {
        "click": this.openPopover
      }
    }, [h("i", {
      "class": "fa fa-pencil-square-o",
      "attrs": {
        "aria-hidden": "true"
      }
    })]), h("div", {
      "slot": "icon"
    }), h("div", {
      "slot": "content"
    }, [h("h4", ["\u91CD\u547D\u540D\u9009\u62E9\u5668"]), h("a-form-model", _mergeJSXProps([{}, {
      "props": {
        model: formModelData
      }
    }, {
      "ref": "renameForm",
      "attrs": {
        "rules": this.rules,
        "labelCol": {
          span: 6
        },
        "wrapperCol": {
          span: 16
        }
      },
      "class": styles.renameForm
    }]), [h("a-form-model-item", {
      "attrs": {
        "label": "选择器",
        "extra": "使用.className、#id等对子元素进行选择",
        "prop": "selector"
      }
    }, [h("a-input", {
      "model": {
        value: formModelData.selector,
        callback: $$v => {
          this.$set(formModelData, "selector", $$v);
        }
      }
    })]), h("a-form-model-item", {
      "attrs": {
        "label": "伪类",
        "extra": "css伪类选择器，如 &:focus 鼠标焦点, &:active 鼠标选中",
        "prop": "pseudo"
      }
    }, [h("a-input", {
      "model": {
        value: formModelData.pseudo,
        callback: $$v => {
          this.$set(formModelData, "pseudo", $$v);
        }
      }
    })]), h("a-form-model-item", {
      "attrs": {
        "wrapperCol": {
          offset: 6
        }
      }
    }, [h("div", {
      "class": styles.buttonGroup
    }, [h("a-button", {
      "attrs": {
        "size": "small"
      },
      "on": {
        "click": () => this.visible = false
      }
    }, ["\u53D6\u6D88"]), h("a-button", {
      "attrs": {
        "size": "small",
        "type": "primary"
      },
      "on": {
        "click": this.renameStyleSelector
      }
    }, ["\u4FEE\u6539"])])])])])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], SelectorRenameForm.prototype, "designer", void 0);
__decorate([Prop({
  required: true
})], SelectorRenameForm.prototype, "styleInfo", void 0);
SelectorRenameForm = __decorate([Component({
  name: 'SelectorRenameForm'
})], SelectorRenameForm);
export { SelectorRenameForm };
//# sourceMappingURL=SelectorRenameForm.js.map
